import { fetcher } from '@common/utils/fetcher';

type TaskStatus = 'completed' | 'available';

export interface Task {
  id: number;
  task_type?: 'telegram_channel' | 'external_link' | 'third_party_adpanel';
  verification_method?: 'channel_membership' | 'click_only' | 'adpanel_session';
  title: string;
  description: string;
  target_channel_link: string | null;
  image_url: string;
  button_title?: string;
  is_pinned?: boolean;
  pin_priority?: number;
  status: TaskStatus;
  star_reward?: number;
  premium_days_reward: number;
  premium_reward_hours?: number;
  adpanel_campaign_code?: string;
}

export type PostTaskClickParams = {
  task_id: number;
};

export type PostTaskClickResponse = null;

export type PostTaskShownByIdParams = {
  taskId: number;
  position?: number;
};

export type PostTaskShownByIdResponse = null;

export type PostChannelCheckParams = {
  taskId: number;
};

export type PostChannelCheckResponse = {
  isMember: boolean;
  status: 'member' | 'left';
  rewarded?: boolean;
  alreadyRewarded?: boolean;
  task?: {
    id: number;
    title: string;
    star_reward: number;
    premium_days_reward: number;
    premium_reward_hours?: number;
  };
};

export type StartTaskIntegrationSessionParams = {
  task_id: number;
  app_instance_id: string;
};

export type TaskIntegrationSessionStatus = {
  session_id?: string;
  provider_session_id?: string;
  state: 'issued' | 'started' | 'converted' | 'failed' | 'expired' | string;
  terminal: boolean;
  action_url?: string;
  expires_at?: string;
  rewarded?: boolean;
  alreadyRewarded?: boolean;
  task?: {
    id: number;
    title: string;
    star_reward: number;
    premium_days_reward: number;
    premium_reward_hours?: number;
  };
};

type GetTasksResponse = {
  tasks: Task[];
};

export const getTasks = () => {
  return fetcher<GetTasksResponse>({
    url: '/tasks',
    method: 'GET',
  });
};

export const postTaskClick = ({ task_id }: PostTaskClickParams) => {
  return fetcher<PostTaskClickResponse>({
    url: `/tasks/${task_id}/click`,
    method: 'POST',
  });
};

export const postTaskShownById = ({
  taskId,
  position,
}: PostTaskShownByIdParams) => {
  return fetcher<PostTaskShownByIdResponse>({
    url: `/tasks/${taskId}/shown`,
    method: 'POST',
    data: {
      position,
    },
  });
};

export const postChannelCheck = (params: PostChannelCheckParams) => {
  return fetcher<PostChannelCheckResponse>({
    url: '/channel-check',
    method: 'POST',
    data: params,
  });
};

export const startTaskIntegrationSession = ({
  task_id,
  app_instance_id,
}: StartTaskIntegrationSessionParams) => {
  return fetcher<TaskIntegrationSessionStatus>({
    url: `/tasks/${task_id}/start`,
    method: 'POST',
    data: {
      app_instance_id,
    },
  });
};
